import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'
import { FilterSkeletons, ResultSkeleton, ResultsSkeleton, SkeletonRoot } from './styled'

export default function ResearchListSkeleton({ label }) {
    return (
        <SkeletonRoot aria-label={label}>
            <BaseSkeleton height={48} width="62%" borderRadius={14} />
            <FilterSkeletons>
                {Array.from({ length: 4 }).map((_, index) => <BaseSkeleton key={index} height={40} width={110} borderRadius={20} />)}
            </FilterSkeletons>
            <ResultsSkeleton>
                {Array.from({ length: 5 }).map((_, index) => (
                    <ResultSkeleton key={index}>
                        <BaseSkeleton height={11} width={150} />
                        <BaseSkeleton height={26} width={index % 2 ? '72%' : '88%'} />
                        <BaseSkeleton height={13} width="48%" />
                    </ResultSkeleton>
                ))}
            </ResultsSkeleton>
        </SkeletonRoot>
    )
}
